import { render, staticRenderFns } from "./ModalLightingHistory.vue?vue&type=template&id=18038fe9&scoped=true&"
import script from "./ModalLightingHistory.vue?vue&type=script&lang=js&"
export * from "./ModalLightingHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalLightingHistory.vue?vue&type=style&index=0&id=18038fe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18038fe9",
  null
  
)

export default component.exports